import { User } from "@/models/User";

export const getFullName = (user: User) => `${user.firstName} ${user.lastName}`;
